import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { GOOGLE_CLOUD_STORAGE } from "../../Constants"

function ZdqGoogleCloudStorageConnectorStatus() {
    return <ZdqConnectorStatus vendor={GOOGLE_CLOUD_STORAGE}></ZdqConnectorStatus>
}

export default ZdqGoogleCloudStorageConnectorStatus